import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionQuestInfoTaskSkip } from "../actionQuestInfo";
import { TypeActionQuest } from "../list/actionQuests";
export var epicQuestSkip = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuest.Skip), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.SkipQuestTask,
            props: {
                amount: Long.fromValue(action.amount || 0),
                itemId: IdResource.Gold,
                playerId: state.playerInfo.playerId,
                questId: action.questId,
                taskIndex: action.taskIndex,
            },
        })
            .pipe(switchMap(function (res) {
            var quests = state.questInfo.quest;
            var resQuest = res.quest;
            var questsMap = new Map();
            if (quests != undefined) {
                quests.forEach(function (val) {
                    questsMap.set(val.questId, val);
                });
            }
            if (res.quest !== undefined) {
                if (questsMap.has(resQuest.questId)) {
                    questsMap.set(resQuest.questId, resQuest);
                }
                quests = Array.from(questsMap.values());
            }
            return from([
                actionInventoryInfoRemoveResource([
                    { typeId: res.itemId, amount: res.amount },
                ]),
                actionQuestInfoTaskSkip(quests),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestSkip.ts
// module id = 1969
// module chunks = 3